import type { VideoObject, WithContext } from "schema-dts";

import type { PublisherData } from "./_internal/buildVideoObjectData";
import { buildVideoObjectData } from "./_internal/buildVideoObjectData";

export type VideoObjectJsonLDProps = {
  name?: string;
  description?: string;
  thumbnailUrl?: string;
  thumbnailAlt?: string;
  contentUrl?: string;
  uploadDate?: string;
  duration?: string;
  ineligibleRegion?: string;
  publisher?: PublisherData;
};

function buildVideoObjectJsonLd(props: VideoObjectJsonLDProps): WithContext<VideoObject> | null {
  const videoObject = buildVideoObjectData(props);

  if (!videoObject) {
    return null;
  }

  return { "@context": "https://schema.org", ...videoObject };
}

export function VideoObjectJsonLD(props: VideoObjectJsonLDProps) {
  const jsonLd = buildVideoObjectJsonLd(props);

  if (!jsonLd) {
    return null;
  }

  return <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>;
}
